"use strict";

import React from 'react';

const OrderSampleItem = ({item={product_id: '', name: ''}}) => {
    return (
        <li className="cart__component__list-item">
            <div className="cart__component__list-item__description-column cart__component__list-item__link">
                    <span className="cart__component__list-item__description__sku-label">
                        Item: #{item.product_id}
                    </span>
                {item.name}
            </div>
        </li>
    );
};

export default OrderSampleItem;